// extracted by mini-css-extract-plugin
export var adjacentSlide = "_n0-9";
export var arrowButtonContainer = "_n0-5";
export var arrowButtonIcon = "_n0-6";
export var carouselArrowButton = "_n0-2";
export var carouselElementContainer = "_n0-1";
export var currentSlide = "_n0-8";
export var left = "_n0-3";
export var otherSlide = "_n0-a";
export var productCarouselContainer = "_n0-0";
export var right = "_n0-4";
export var sliderOverflow = "_n0-7";